import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 54px 74px 54px 50px;
  overflow-y: auto;
  
  div.select-existing-contact-container {
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 48px;

    header {
      font-weight: 900;
      font-size: 18px;
      line-height: 24px;
      color: #353744;
      padding-bottom: 8px;
      border-bottom: 2px solid #EFEFEF;
    }

    main {
      background: inherit;

      article {
        margin: 48px 0;

        section + section {
          margin-top: 24px;
        }
      }

      footer {
        display: flex;
        gap: 24px;
      }
    }
  }
`

export const CheckboxLabel = styled.h6`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #353744;
`

export const ExistingContactTable = styled.table`
  .contact-key {
    width: 110px;
  }
  th {
    text-align: left;
  }
  th,td {
    padding-bottom: 10px;
  }

`